import { IDocument, IUploadFile, UploadedFile } from "../common/services/document-management.service";
import { IReportContextValue } from "../models/comodel/mergefieldsmodel.model";

export class LetterCreationRequest {
    public mail: Letter;
    public temporaryDocument: IDocument;
    public letterContent: string;
    public reportContextValues: IReportContextValue[];
    public letterAttachments: LetterAttachment[];
}

export class SaveLetterWithAttachmentsRequest {
    public mail: Letter;
    public updatedLetterContent: string;
    public letterAttachments: LetterAttachment[];
}

export class PdfMergeConfig {
    public stampPageNumberFooter: boolean = false;
    public prefixPageNumberFooterWithExhibitLetter: boolean = false;

    public htmlHeader: string = "";
    public htmlFooter: string = "";

    //This should be an interpolated string, such as "Page {0} of {1}" Note,  {0} of {1} will be automatically be filled in with page count numbers at runtime
    public stampPageNumberFooterTemplate: string = "Page {0} of {1}";

    //reference the IronPdf.PdfPrintOptions.PdfPaperSize for valid names
    public pageType: string = "Letter";
}

export enum MailDeliveryType {
    Regular = "Regular",
    Certified = "Certified",
    CertificateOfMailing = "CertificateOfMailing",
    HandDelivery = "HandDelivery",
    Other = "Other"
}


export class Letter {
    public id?: string;
    public office: LetterAddress;
    public recipient: LetterAddress;
    public organizationId: string;
    public organizationName: string;
    public createdDate?: Date;
    public sentDate?: Date;
    public title: string;
    public documentTypeId: string;
    public htmlDocumentId?: string;
    public chiefsOrderNumber?: string;
    public pdfDocumentId?:string;
    public status?: LetterStatus;
    public labelSize?: LabelSizeKind;
    public pageCount: number = 0;
    public additionalPageCount?: number = 0;

    public isCertified: boolean = false;

    public costCode?: string;
    public referenceLine?: string;

    public notifySender?: boolean = true;
    public notificationEmail?: string;
    public restrictDelivery?: boolean = true;
    public trackRRE: boolean = true;

    public trackingNumber?: string;
    public labelCost?: number = 0.0;

    public deliveryDate?: Date;
    public signatureName?: string;
    public trackingStatus?: string;
    public acceptedDate?: Date;
    public acceptedText?: string;

    public haveGeneratedLabel?: boolean = false;
    public haveSignatureDocument?: boolean;
    public haveDeliveryDocument?: boolean;
    public haveAcceptanceDocument?: boolean;
    public mailType?: string;
    public recipientName?: string;
    public recipientNames?: string;

    public onBaseDocumentTypeName: string;
    public onBaseFileName: string;
    public onBaseDocumentId? : number;
    public onBaseSignatureDocId? : number;
    public onBaseDeliveryDocId? : number;
    public onBaseAcceptanceDocId?: number;
    public queuedDocumentId?: string;
    public queuedSignatureDocId?: string;
    public queuedDeliveryDocId?: string;
    public queuedAcceptanceDocId?: string;

    public otherReason?: string;

    public mergeConfig: PdfMergeConfig;
}

export enum LabelSizeKind {
  No10Letter = 0,
  Full9x12 = 1
}

export enum AssociateDocumentKind {
  Label = 1,
  Signature = 2,
  Delivery = 3,
  Acceptance = 4,

}

export enum LetterStatus {
  Pending = 0,
  Sent = 1,
  Delivered = 2,
  Returned = 3,
  Unknown = 4
}

export class LetterAddress {
  public title?:string;
  public name1: string;
  public name2?: string;
  public name3?: string;
  public address1: string;
  public address2?: string;
  public address3?: string;
  public city?: string;
  public state?: string;
  public zipCode?: string;
  public zipPlus4?: string;
}

export class LetterSearchCriteria {
  public startDate?: Date | null;
  public endDate?: Date | null;
  public mailType?: string;
  public inStatuses: LetterStatus[] = [];
  public trackingNumber?: string;
  public chiefsOrderNumber?: string;


  public orderByPropertyName:string = "CreatedDate";
  public orderDirection:LetterSearchOrderDirection = LetterSearchOrderDirection.Descending;
}

export class LetterStatusUpdateRequest {
    public letterId: string;
    public status: LetterStatus;
}

export class LetterAttachment {
    public letterId: string;
    public onbaseDocumentType: string;
    public blobUri: string;
    public sentToOnbase: boolean;
    public fileName: string;
    public type: string;
    public shouldBeMergedIntoLetter: boolean;
    public order: number;

    constructor(uploadedFile: IUploadFile, shouldBeMergedIntoLetter: boolean = false, order: number = 0) {
        this.onbaseDocumentType = uploadedFile.documentType;
        this.blobUri = uploadedFile.blobUri;
        this.fileName = uploadedFile.fileName;
        this.type = uploadedFile.type;
        this.shouldBeMergedIntoLetter = shouldBeMergedIntoLetter;
        this.order = order;

        if (uploadedFile.sentToOnbase != undefined && uploadedFile.sentToOnbase != null)
            this.sentToOnbase = uploadedFile.sentToOnbase;
        else
            this.sentToOnbase = false;
    }

    toUploadedFile(): UploadedFile {
        let uploadedFile = {
            completed: true,
            blobUri: this.blobUri,
            isUploading: false,
            sentToOnbase: this.sentToOnbase,
            documentType: this.onbaseDocumentType,
            type: this.type,
            fileName: this.fileName,
        } as UploadedFile;
        return uploadedFile;
    }
}

export enum LetterSearchOrderDirection
{
    Ascending = 0,
    Descending = 1,
}
